import * as Yup from 'yup';
import { TType } from '@translations/translationsTypes';

const PERSONAL_DOMAINS = ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com'];

// company email validator
const isCompanyEmailValidator = (value?: string) => {
  const domain = value?.split('@')[1]?.toLowerCase();
  return !!domain && !PERSONAL_DOMAINS.includes(domain);
};

export const IBSRequestValidationScheme = (t: TType) => {
  return Yup.object()
    .shape({
      name: Yup.string().required(t('global.error.required')),
      phoneNumber: Yup.string()
        .required(t('global.error.required'))
        .matches(/^(\+966|00966|966)\d{9}$/, t('global.error.validPhone')),
      email: Yup.string()
        .required(t('global.error.required'))
        // .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, t('global.error.email'))
        .test('company-email', t('global.error.companyEmail'), isCompanyEmailValidator),
      entityName: Yup.string().required(t('global.error.required')),
      entityAddress: Yup.string().required(t('global.error.required')),
      serviceTypeId: Yup.string().required(t('global.error.required')),
      buildingTypeId: Yup.string().required(t('global.error.required')),
      numberOfBuildings: Yup.string().required(t('global.error.required')),
      recaptchaToken: Yup.string().required(t('global.error.required')),
      termsOfUse: Yup.bool().equals([true], t('global.error.required')),
      privacyNotice: Yup.bool().equals([true], t('global.error.required')),
      cstConditions: Yup.bool().equals([true], t('global.error.required')),
    })
    .nullable();
};
